import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-reports',
  templateUrl: './home-reports.component.html',
  styleUrls: ['./home-reports.component.css']
})
export class HomeReportsComponent implements OnInit {
  role:number = 3;

  constructor() { }

  ngOnInit() {
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    } 
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/components/home-reports/home-reports.component.ts